import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

type Props = {
  onDetect: (code: string) => void;
  paused?: boolean;
  hint?: string;
};

export function Scanner({ onDetect, paused, hint = "Inquadra il QR / barcode" }: Props) {
  const containerId = "tcg-qr-reader";
  const ref = useRef<Html5Qrcode | null>(null);
  const callbackRef = useRef(onDetect);
  callbackRef.current = onDetect;
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<"pronto" | "scanning" | "errore">("pronto");

  useEffect(() => {
    if (paused) return;
    const el = document.getElementById(containerId);
    if (!el) return;
    const q = new Html5Qrcode(containerId, { verbose: false });
    ref.current = q;
    let cancelled = false;

    q.start(
      { facingMode: "environment" },
      { fps: 12, qrbox: { width: 240, height: 150 } },
      (decoded) => {
        if (cancelled) return;
        callbackRef.current(decoded);
      },
      () => {},
    )
      .then(() => {
        if (!cancelled) setStatus("scanning");
      })
      .catch((err) => {
        setStatus("errore");
        setError(String(err?.message || err));
      });

    return () => {
      cancelled = true;
      q.stop()
        .catch(() => {})
        .finally(() => {
          try {
            q.clear();
          } catch {
            /* noop */
          }
        });
    };
  }, [paused]);

  return (
    <div className="tcg-scanner">
      <div id={containerId} className="tcg-scanner-video" />
      <div className="tcg-scanner-grid" />
      <div className="tcg-scanner-pill">
        <span className="tcg-scanner-dot" />
        CAMERA · {status.toUpperCase()}
      </div>
      <div className="tcg-scanner-frame">
        <div className="tcg-scanner-corner" style={{ top: -3, left: -3, borderRight: "none", borderBottom: "none", borderTopLeftRadius: 10 }} />
        <div className="tcg-scanner-corner" style={{ top: -3, right: -3, borderLeft: "none", borderBottom: "none", borderTopRightRadius: 10 }} />
        <div className="tcg-scanner-corner" style={{ bottom: -3, left: -3, borderRight: "none", borderTop: "none", borderBottomLeftRadius: 10 }} />
        <div className="tcg-scanner-corner" style={{ bottom: -3, right: -3, borderLeft: "none", borderTop: "none", borderBottomRightRadius: 10 }} />
        <div className="tcg-scanner-line" />
      </div>
      <div className="tcg-scanner-hint">{error || hint}</div>
    </div>
  );
}
